import { useMutation } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { updateCustomerProfile } from 'src/services/napi/customers/updateCustomerProfile';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import {
  UpdateCustomerProfileProps,
  UseMutationInterface
} from './interfaces/useUpdateCustomerProfile.interface';
import { useNotification } from '../../../providers/notificationsProvider';

const updateCustomerProfileData = async ({ profileId, body }: UpdateCustomerProfileProps) => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject?._id) return;

  await updateCustomerProfile(currentProject._id, profileId, body);
};

export const useUpdateCustomerProfile = ({ onError, onSuccess }: UseMutationInterface) => {
  const { notify } = useNotification();

  return useMutation((data: UpdateCustomerProfileProps) => updateCustomerProfileData(data), {
    onError: () => {
      notify({ message: 'something went wrong', severity: 'error' });
      if (onError) {
        onError();
      }
    },
    onSuccess: () => {
      if (onSuccess) {
        onSuccess();
      }
    }
  });
};
